export default __webpack_public_path__ + "static/media/2day-intensiveTraining.4dae0916.png";